// extracted by mini-css-extract-plugin
module.exports = {"menu-page-container":"menu_menu-page-container__jd9Mb"};